import { CallOptions } from '@wui/jssip/lib/UA'

import { getUA } from './use-web-rtc'

export const call = (target: string, options: CallOptions): string | undefined => {
  const rtcSession = getUA()?.call(target, options)

  return rtcSession?.id
}
